const C = {
  primary: "#1a365d",
  success: "#0ab39c",
  danger: "#f06548",
  warning: "#f7b84b",
  muted: "#79747e",
  border: "rgba(73, 69, 79, 0.08)",
};

export default C;
